import { render, staticRenderFns } from "./Alumnus.vue?vue&type=template&id=21571b82&scoped=true&"
import script from "./Alumnus.vue?vue&type=script&lang=js&"
export * from "./Alumnus.vue?vue&type=script&lang=js&"
import style0 from "./Alumnus.vue?vue&type=style&index=0&id=21571b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21571b82",
  null
  
)

export default component.exports